import {connect} from 'react-redux';
import ProfileUserBlock from '../../../components/blocks/profile/ProfileUserBlock';
import {
    getUser,
    changeValue,
    editUser,
    saveUser
} from '../../../actions/userAction';

const mapStateToProps = state => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getUser() {
            dispatch(getUser())
        },
        handleTextInputChange(e) {
            dispatch(changeValue(e.target.name, e.target.value))
        },
        handleCheckboxInputChange(e) {
            dispatch(changeValue(e.target.name, e.target.checked))
        },
        editUser() {
            dispatch(editUser())
        },
        handleFormSubmit(data) {
            dispatch(saveUser(data))
        }
    }
};

const ProfileUserBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileUserBlock);

export default ProfileUserBlockContainer;